import { mediumFont, theme } from "../../utils/styles";

const professionAnalysisStyle = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  scrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "35px",
    },
  },
  darkTextField: {
    borderRadius: "0px",
    border: "none",
    background: "transparent",
    boxShadow: "none",

    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },

    "& .MuiSelect-outlined": {
      border: "none",
      position: "relative",
      padding: "0px 0px",
      color: "#ffffff",
      fontSize: "20px",
      [theme.breakpoints.down("sm")]: {
        padding: "0px 0px",
      },

      "&::placeholder": {
        ...mediumFont,
        color: "#ffffffA6",
      },
    },
    "& .MuiSelect-icon": {
      color: "#ffffff",
      top: "calc(50% - 0.6em)",
    },
    "& ..MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
  },
} as const;

export default professionAnalysisStyle;
